import React, { MouseEventHandler, ReactNode } from "react";
import { createPortal } from "react-dom";

import './popup.css';

const portal = document.createElement('div');
portal.id = 'popup';
document.body.appendChild(portal);

function backdropClick(onClose: (() => void) | undefined): MouseEventHandler<HTMLDivElement> | undefined {
    if (!onClose) {
        return undefined;
    }
    return (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };
}

export default function Popup({ children, onClose }: PopupProps) {
    return createPortal(<div className='filler' onClick={backdropClick(onClose)}>
        <div className='popup'>
            <div className='popup2'>
                {children}
            </div>
        </div>
    </div>, portal)
}

export type PopupProps = {
    children: ReactNode
    onClose?: () => void
}

export function PopupTabs({ children, onClose }: PopupTabsProps) {
    return createPortal(<div className='filler' onClick={backdropClick(onClose)}>
        <div className='popup-tab'>
            <div className='popup2-tab'>
                {children}
            </div>
        </div>
    </div>, portal)
}

export type PopupTabsProps = {
    children: ReactNode
    onClose?: () => void
}